import { render, staticRenderFns } from "./ReferentialView.vue?vue&type=template&id=d6060ef4&scoped=true&"
import script from "./ReferentialView.vue?vue&type=script&lang=js&"
export * from "./ReferentialView.vue?vue&type=script&lang=js&"
import style0 from "./ReferentialView.vue?vue&type=style&index=0&id=d6060ef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6060ef4",
  null
  
)

export default component.exports